export default __webpack_public_path__ + "locales/fr/InfoPanel.json?hash=d93036a95b5d71d13375ed1293a79594";